import { useTheme } from "@mui/material/styles";

import useNav from "core/hooks/useNav";

import Box from "ui/atom/Box";
import Actions from "ui/base/Actions";
import Message from "ui/Message";
import Page from "ui/Page";

import { useBuyGift } from "areas/unlock/fabric";
import Wallet from "areas/unlock/ui/Wallet";
import Info from "areas/unlock/ui/Info";


const Content = () => {
	const nav = useNav();
	const gift = useBuyGift();

	const style = {
		root: { width: "100%", alignItems: "center" },
		actions: { maxWidth: "270px", width: "100%", m: "0 auto", gap: 2, alignItems: "center" }
	};

	const actions = [
		{ label: "Share Gift", variant: "contained", onClick: () => gift.share(gift.mutation.data?.url || gift.data?.gift?.url), color: "success", hide: !gift.isBought },
		{ label: "Buy another gift", variant: "contained", onClick: () => gift.buyAnother(), color: "tertiary", hide: !gift.isBought },
		{ label: "Send Gift", variant: "contained", onClick: () => gift.mutation.mutate(gift.data?.id), color: "tertiary", disabled: !gift.data?.canUnlock, loading: gift.isPending, hide: gift.isBought },
		{ label: "Back", variant: "outlined", onClick: nav.back, size: "small", sx: { width: "100px" } }
	];

	if (gift.isError) return <Message icon="ticket-x" color="error" text={gift.error?.errors?.[""]?.[0]} back={() => nav.go({ to: "/" })} />;
	return (
		<Box.Column gap={2.5} sx={style.root}>
			<Info title={gift.copy.title} description={gift.copy.description} article={gift.data} showCost />
			<Actions actions={actions} sx={style.actions} />
		</Box.Column>
	);
};

export default function Gift() {
	const theme = useTheme();
	const gift = useBuyGift();

	const style = {
		page: {
			justifyContent: { xs: "flex-start", sm: "center" },
			gap: 2.5,
			p: { xs: theme.spacing(0.75, 2), sm: theme.spacing(2.5, 2) }
		},
		body: { gap: 4, mb: 2 }
	};

	return (
		<Page maxWidth="dark" sx={style.page}>
			<Page.Header>
				{!gift.isError && <Wallet />}
			</Page.Header>
			<Page.Body sx={style.body}>
				<Content />
			</Page.Body>
		</Page>
	);
}